import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Box, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

export default function AppHeaderNotifications({ unreadMessageCounts }) {
  const navigate = useNavigate();
  const totalUnread = unreadMessageCounts?.totalUnread ?? 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        aria-label={`${totalUnread} unread notifications`}
        onClick={() => navigate('/r/v2/intervene')}
      >
        <Badge
          color="secondary"
          badgeContent={totalUnread}
          max={999}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Box>
  );
}

AppHeaderNotifications.propTypes = {
  unreadMessageCounts: PropTypes.object,
};
